/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum AuditKind {
    Added = '0',
    Modified = 1,
    Deleted = 2,
}
